import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

export class ProductGroupForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet): void {
    viewSet.viewAdd(new CerFormView({
      viewMetadata: {
        dataApiName: 'ProductGroup',
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'sorting', 'history'],
        navigations: [{ link: 'nav', foreignKey: { parentEntity: 'WarehouseOnhandCostPriceGroupAge', parentColumn: 'group', column: 'num' } }]
      }
    })
    );
  }
}
